// Types
import type { ContractViewerHookType } from '../hooks/types/contract-viewer.hook.type';

const viewerHasNoPdfUrlOrIsLandscape = ({
  landscape,
  memorizedPdfUrl,
}: Pick<ContractViewerHookType, 'landscape' | 'memorizedPdfUrl'>): boolean =>
  Boolean(landscape || !memorizedPdfUrl);

export { viewerHasNoPdfUrlOrIsLandscape };
